import { useNotificationHandler } from '../hooks/useNotificationHandler';

const hasNullResolution = (selectedResolutions) => {
    return Object.values(selectedResolutions).some(resolution => {
        return resolution && (resolution.spatial === null || resolution.temporal === null);
    });
};

function errorChecker(setErrorMessage, setLoading, startDate, endDate, selectedResolutions, tscCoords, openNotification) {
    let errorStr = '';

    if (!startDate && !endDate) {
        errorStr += 'Select a start date and an end date |\n';
    } else if (!startDate) {
        errorStr += 'Select a start date |\n';
    } else if (!endDate) {
        errorStr += 'Select an end date |\n';
    }

    if (Object.keys(selectedResolutions).length === 0) {
        errorStr += 'Select at least one layer |\n';
    }

    // Checks if there are layers with only one type of resolution selected
    if (hasNullResolution(selectedResolutions)) {
        errorStr += 'Select a temporal and spatial resolution for each desired layer |\n';
    }

    // First checks if tscCoords exists because when called from TimeSeriesRender, it isn't passed
    if (tscCoords && (tscCoords.lat === '' || tscCoords.lng === '')) {
        errorStr += 'Select a coordinate |\n';
    }

    if (errorStr.length !== 0) {
        setErrorMessage(errorStr);
        if (openNotification) {
            openNotification(true, "Error", errorStr);
        }
        setLoading(false);
        return true;
    }

    return false;
}

export default errorChecker;